import { Modal, OfferView, OfferViewKEK } from "components";

import { LocationGenerics } from "router/location";
import { useKEKOffer } from "hooks/data/use-offers";
import { useSearch } from "react-location";

export default function ViewKekReinsurerOfferContainer({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { offer, loading } = useKEKOffer({
        offer_id: searchParams.id as string,
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={loading}
            title="Offer Information"
            description="Details of offer are shown below">
            <OfferViewKEK offer={offer} />
        </Modal>
    );
}
